<template>
    <v-container id="walkin_success">
        <v-row>
            <v-col class="d-flex justify-center">
                <v-img src="@/assets/checkmark-circle-grey-green.png" rel="preload" max-width="25%" alt="Success!">
                    <template v-slot:placeholder>
                        <v-row class="fill-height ma-0"
                               align="center"
                               justify="center">
                            <v-skeleton-loader type="image" max-height="200"></v-skeleton-loader>
                        </v-row>
                    </template>
                </v-img>
            </v-col>
        </v-row>
        <v-row>
            <v-col class="text-center">
                <span style="display: block; font-size: 18px;">Great! Thank you for signing in at:</span>
                <strong style="display: block; font-size: 18px;">{{ currentModel.settings.clientName }}</strong>
            </v-col>
        </v-row>
        <v-row v-if="showPtt">
            <v-col class="text-center">
                <span style="display: block; font-size: 18px;">Your projected treatment time is:</span>
                <strong style="font-size: 18px;">{{ currentModel.availableTime.actualAvailableTimeDisplay.substr(0,8) }}</strong>
            </v-col>
        </v-row>
        <v-row v-if="confirmationMessage">
            <v-col class="text-center" style="font-size: 18px;">
                <p>
                    {{ confirmationMessage }}
                </p>
            </v-col>
        </v-row>
        <v-row v-if="currentModel.settings.clientPhone">
            <v-col class="text-center">
                <p style="font-size: 16px;">
                    Please call us if you need to cancel, make changes or have questions:
                </p>
                <a :href="'tel:' + currentModel.settings.clientPhone" style="font-weight: 700; font-size: 18px;">{{currentModel.settings.clientPhone}}</a>
            </v-col>
        </v-row>
        <v-row v-if="!$store.state.jotFormRedirectUrl">
            <v-col class="text-center">
                <v-btn large color="secondary" @click="backToLobbyInternal" raised style="font-size: 18px; font-weight: 700;">{{ currentModel.settings.localizedContent['reservation_success_label'] }}</v-btn>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
    /*eslint-disable no-debugger*/
    import ContextualMixin from '../mixins/contextualMixin'
    var walkinSuccessTimeout;
    export default {
        name: 'WalkinSuccess',
        mixins: [ContextualMixin],
        computed: {
            confirmationMessage() {
                if (!this.currentModel || !this.currentModel.settings.localizedContent)
                    return null;
                return this.currentModel.settings.localizedContent['walkin_confirmation_message'] || null;
            }
        },
        mounted() {
            this.$store.state.currentStep = 0;
            if (!this.$store.state.reservationConfirmationNumber) {
                this.backToLobby();
                return;
            }
            if (this.$store.state.jotFormRedirectUrl) {
                setTimeout(() => {
                    this.$router.push({
                        name: 'walkin_redirect',
                        params: { clientId: this.currentModel.settings.clientId }
                    });
                }, 1500);
            } else {
                if (this.currentModel.settings.redirectToHomePage) {
                    walkinSuccessTimeout = setTimeout(() => {
                        this.backToLobby();
                    }, 15000);
                }
                document.getElementById('walkin_success').scrollTop = 0;
            }
        },
        methods: {
            backToLobbyInternal() {
                clearTimeout(walkinSuccessTimeout);
                this.backToLobby();
            }
        }
    }
</script>